import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { APP_ROUTE_PATHS } from '../../routing/appRoutes';

const useCollapsibleMenu = () => {
  const location = useLocation();

  useEffect(() => {
    // Since the main menu items are the menu-items we have to collapse,
    // we have to cut the location.pathname and take the main menu path from the full path.
    const activeAppRoute = Object.entries(APP_ROUTE_PATHS).find(([, routePath]) => {
      const activeSection = location.pathname.split('/')[1];
      const routeSection = routePath.split('/')[1];
      return activeSection === routeSection;
    });

    const activeAppSubChildRoute = Object.entries(APP_ROUTE_PATHS).find(([, routePath]) => {
      const two = 2;
      const activeSubChildSection = location.pathname.split('/')[two];
      const routeSection = routePath.split('/')[two];
      return activeSubChildSection === routeSection;
    });

    if (activeAppRoute) {
      setOpenMenus((prevOpenMenus) => ({
        ...prevOpenMenus,
        [APP_ROUTE_PATHS[activeAppRoute[0]]]: true,
      }));
    }

    if (activeAppSubChildRoute) {
      setOpenSubChildMenus((prevOpenSubChildMenus) => ({
        ...prevOpenSubChildMenus,
        [APP_ROUTE_PATHS[activeAppSubChildRoute[0]]]: true,
      }));
    }
  }, [location]);

  const [openSubMenu, setOpenMenus] = useState<{ [key: string]: boolean }>({
    [APP_ROUTE_PATHS.GALLERY_MAIN_MENU]: false,
  });

  const [openSubChildMenu, setOpenSubChildMenus] = useState<{ [key: string]: boolean }>({});

  const toggleSubMenu = (menuPath: string) => {
    setOpenMenus((prevOpenMenus) => ({
      ...prevOpenMenus,
      [menuPath]: !prevOpenMenus[menuPath],
    }));
  };

  const toggleSubChildMenu = (menuPath: string) => {
    setOpenSubChildMenus((prevOpenMenus) => ({
      ...prevOpenMenus,
      [menuPath]: !prevOpenMenus[menuPath],
    }));
  };

  const isActiveRoute = (routeName: string): boolean => {
    const currentPath = window.location.pathname;

    if (routeName === '/') {
      return currentPath === routeName;
    }

    // For exact matching, check if the path matches exactly or if it's a sub-route
    // but ensure we don't match partial route names
    if (currentPath === routeName) {
      return true;
    }

    // For sub-routes, ensure the next character after the route name is a slash
    // This prevents /sample-delivery-note from matching /sample-delivery
    return currentPath.startsWith(routeName + '/');
  };

  return {
    openSubMenu,
    openSubChildMenu,
    toggleSubMenu,
    toggleSubChildMenu,
    isActiveRoute,
  };
};

export default useCollapsibleMenu;
